class LocationService {
    constructor($rootScope, $timeout, $log, wtcpjsClientProviderService, endpointModel, settingsService, timeFormattingService) {
        var locSvc = this;

        this.$rootScope = $rootScope;
        this.$log = $log;
        this.settingsService = settingsService;
        this.timeFormattingService = timeFormattingService;
        this.sendGeoTimeout = null;
        this.sharingGeolocation = true;
        this.endpointModel = endpointModel;
        this.setTimeout = $timeout;
        this.clearTimeout = $timeout.cancel;
        this.sharingLocation = false;
        this.client = wtcpjsClientProviderService.getClient();
        this.loopFrequency = 300000; // 5 minutes
        this.loopCount = 0;

        function reset() {
            locSvc.clearTimeout(locSvc.sendGeoTimeout);
            locSvc.loopCount = 0;
            locSvc.sharingLocation = false;
            locSvc.sharingGeolocation = false;
        }

        $rootScope.$on("settingsService.shareLocation", (e, isSharing) => {
            if (isSharing) {
                locSvc.shareLocation();
            }
            else {
                locSvc.stopSharingLocation();
            }
        });

        $rootScope.$on("ConnectionService.connectionClosed", (e) => {
            locSvc.$log.debug("locationService: connectionClosed, resetting location service state");
            reset();
        });

        $rootScope.$on("ConnectionService.logout", (e) => {
            reset();
        });

        $log.info('Location Service initialized');
    }

    loopGeolocation(endpointId) {

        var locSvc = this;
        this.loopCount++;

        return new Promise(function(resolve, reject) {
            locSvc.sharingLocation = true;
            if(locSvc.sendGeoTimeout){
                locSvc.clearTimeout(locSvc.sendGeoTimeout);
            }
            locSvc.sendGeoTimeout = locSvc.setTimeout(() => { locSvc.loopGeolocation(endpointId); }, locSvc.loopFrequency);

            if (!locSvc.sharingGeolocation) {
                reject("geolocation not enabled");
            }

            if (!locSvc.settingsService.location) {
                 navigator.geolocation.getCurrentPosition(function(position) {
                     let _lat = position.coords.latitude.toFixed(8);
                     let _lng = position.coords.longitude.toFixed(8);
                     locSvc.endpointModel.setLocation(endpointId, { 'lat': _lat, 'lng': _lng });

                     if(locSvc.loopCount === 1) {
                         locSvc.$rootScope.$broadcast("locationService.sharingLocation", locSvc.endpointModel.getEndpoint(endpointId));
                     }

                     resolve(locSvc.sendGeolocation(endpointId, _lat, _lng));
                 });
            } else {
                resolve(locSvc.sendGeolocation(endpointId, locSvc.settingsService.location.lat, locSvc.settingsService.location.lng));
            }
        });
    }

    sendGeolocation(endpointId, lat, long) {
        // If browser supports geolocation and option is enabled
        if (!lat || !long) {
            return this.client.setEndpointProperties(endpointId, {
                    location: ""
                })
                .then((resp) => {
                    this.$log.debug("Endpoint Location cleared");
                    return resp;
                })
                .catch((err) => {
                    this.$log.error("There was an error trying to clear the location endpoint properity");
                    return err;
                });
        } else {
            let t = this.timeFormattingService.formatLocationDate(new Date());
            return this.client.setEndpointProperties(endpointId, {
                    location: `t=${t},lo=${long},la=${lat}`
                })
                .then((resp) => {
                    this.$log.debug(`Endpoint Location set: Time: ${t}, Latitude: ${lat}, Longitude: ${long} for Endpoint Id: ${endpointId}`);
                    return resp;
                })
                .catch((err) => {
                    this.$log.error('There was an error trying to set location endpoint properites', err);
                    return err;
                });
        }
    }

    setLocation(lat, lng) {
        if (lat && lng) {
            this.settingsService.location = { lat, lng };
            this.clearTimeout(this.sendGeoTimeout);
            this.loopGeolocation(this.endpointModel.getMyEndpoint().id);
        } else
            this.settingsService.location = null;
    }

    shareLocation() {
        let locSvc = this;

        return new Promise(function(resolve, reject) {
            if (locSvc.sharingLocation) reject("error in locationService: you are already sharing location");

            if (locSvc.settingsService.shareLocation) {
                if (locSvc.settingsService.location || "geolocation" in navigator) {
                    locSvc.sharingGeolocation = true;
                    var ep = locSvc.endpointModel.getMyEndpoint();
                    locSvc.loopGeolocation(ep.id).then(function(p) {
                        resolve(p);
                    });
                } else {
                    locSvc.settingsService.shareLocation = false;
                    reject("Location has not been set by user and browser has disabled geolocation");
                }
            } else {
                resolve("User not sharing location");
            }
        });
    }

    stopSharingLocation() {
        this.loopCount = 0;
        this.sharingGeolocation = false;
        this.clearTimeout(this.sendGeoTimeout);
        this.sendGeolocation(this.endpointModel.getMyEndpoint().id);
    }

    get isSharingEnabled() {
        return this.settingsService.shareLocation;
    }
}

angular.module('webcomm').service('locationService',
    [
        '$rootScope',
        '$timeout',
        '$log',
        'wtcpjsClientProviderService',
        'endpointModel',
        'settingsService',
        'timeFormattingService',
        LocationService
    ]);